module.exports = {
	"id": "CU",
	"name": "Cuba",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": 0.017498,
			"10": null,
			"11": 0.017498,
			"12": null,
			"13": null,
			"14": 0.017498,
			"15": null,
			"16": null,
			"17": 0.017498,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.017498,
			"23": 0.122486,
			"24": null,
			"25": 0.034996,
			"26": 0.034996,
			"27": null,
			"28": 0.008749,
			"29": 0.043745,
			"30": 0.017498,
			"31": 0.043745,
			"32": 0.026247,
			"33": 0.096239,
			"34": 0.078741,
			"35": 0.034996,
			"36": 0.043745,
			"37": 0.043745,
			"38": 0.236223,
			"39": 0.034996,
			"40": 0.043745,
			"41": 0.061243,
			"42": 0.061243,
			"43": 0.104988,
			"44": 0.043745,
			"45": 0.08749,
			"46": 0.183729,
			"47": 0.104988,
			"48": 0.148733,
			"49": 0.367458,
			"50": 0.218725,
			"51": 0.271219,
			"52": 0.376207,
			"53": 3.622086,
			"54": 0.813657,
			"55": 0.026247,
			"56": null,
			"57": null
		},
		"firefox": {
			"2": 0.454948,
			"3": 0.026247,
			"4": 0.061243,
			"5": 0.78741,
			"6": 0.139984,
			"7": 0.061243,
			"8": 0.078741,
			"9": 0.122486,
			"10": 0.08749,
			"11": 0.061243,
			"12": 0.069992,
			"13": 0.069992,
			"14": 0.061243,
			"15": 0.244972,
			"16": 0.183729,
			"17": 0.209976,
			"18": 0.096239,
			"19": 0.157482,
			"20": 0.148733,
			"21": 0.227474,
			"22": 0.209976,
			"23": 0.367458,
			"24": 1.084876,
			"25": 0.647426,
			"26": 0.673673,
			"27": 0.498693,
			"28": 0.131235,
			"29": 0.559936,
			"30": 0.376207,
			"31": 0.603681,
			"32": 2.88717,
			"33": 0.883649,
			"34": 1.7498,
			"35": 0.822406,
			"36": 0.559936,
			"37": 2.502214,
			"38": 2.895919,
			"39": 1.57482,
			"40": 2.598453,
			"41": 1.592318,
			"42": 1.513577,
			"43": 3.893305,
			"44": 1.303601,
			"45": 3.447106,
			"46": 2.747186,
			"47": 13.377221,
			"48": 4.864444,
			"49": 15.765698,
			"50": 0.559936,
			"51": 0.069992,
			"52": 0.026247,
			"3.5": 0.096239,
			"3.6": 0.139984
		},
		"opera": {
			"9": null,
			"11": null,
			"12": 0.026247,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.017498,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.061243,
			"30": null,
			"31": null,
			"32": 0.043745,
			"33": 0.017498,
			"34": 0.017498,
			"35": null,
			"36": 0.008749,
			"37": 0.026247,
			"38": 0.026247,
			"39": 0.026247,
			"40": 0.148733,
			"41": 0.034996,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": 0.008749,
			"11.1": null,
			"11.5": null,
			"11.6": 0.026247,
			"12.1": 0.078741
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.034996,
			"6": null,
			"7": null,
			"8": 0.017498,
			"9": 0.026247,
			"10": 0.104988,
			"3.1": null,
			"3.2": null,
			"5.1": 0.017498,
			"6.1": null,
			"7.1": null,
			"9.1": 0.078741
		},
		"ios_saf": {
			"8": 0,
			"10": 0.573428509575,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0154532348043,
			"8.1-8.4": 0.0285491965029,
			"9.0-9.2": 0.0136198001665,
			"9.3": 0.207789258951
		},
		"android": {
			"3": 0,
			"4": 0.0334934263566,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00418667829457,
			"4.1": 0.120815573643,
			"4.2-4.3": 0.302038934109,
			"4.4": 0.692596209302,
			"4.4.3-4.4.4": 0.698577178295
		},
		"ie": {
			"6": null,
			"7": 0.017498,
			"8": 0.971139,
			"9": 0.148733,
			"10": 0.279968,
			"11": 1.391091,
			"5.5": null
		},
		"op_mob": {
			"0": 0.00906582934244,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000251828592846
		},
		"edge": {
			"12": 0.279968,
			"13": 0.131235,
			"14": 0.078741
		},
		"ie_mob": {
			"10": 0.0209842253521,
			"11": 0.0854357746479
		},
		"bb": {
			"7": 0.010016,
			"10": null
		},
		"samsung": {
			"0": 0.68234
		},
		"and_uc": {
			"0": 0.305488
		},
		"op_mini": {
			"0": 0.122142342065
		},
		"and_chr": {
			"0": 7.208026
		},
		"and_ff": {
			"0": 1.878
		}
	},
	"total": 99.058713
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/CU.json
 ** module id = 501
 ** module chunks = 0
 **/